<section class="terms section">
  <div class="shell-container terms__grid">
    <div class="terms__intro">
      <div class="badge">Terms of Service</div>
      <h1>Our studio policies and service terms</h1>
      <p class="terms__lede">
        These terms explain how we schedule, provide, and support grooming services for your pets.
      </p>
      <p class="terms__meta">Last updated: January 29, 2026</p>
    </div>

    <div class="terms__content">
      <h2>Appointments and timing</h2>
      <p>
        Appointment times are estimates. Grooming duration depends on coat condition, service level, and
        your pet’s comfort. We will keep you informed during your visit.
      </p>

      <h2>Health and vaccinations</h2>
      <p>
        For the safety of all pets and staff, current vaccinations may be required. Please share any
        health conditions, allergies, or mobility needs before the appointment.
      </p>

      <h2>Handling and safety</h2>
      <p>
        Our team uses gentle, pet-first techniques. If a pet becomes overly stressed, we may pause or
        end the session and discuss the safest next steps with you.
      </p>

      <h2>Payments and pricing</h2>
      <p>
        Pricing is based on size, coat condition, and time required. Any changes are discussed before
        proceeding. Add-ons are always optional.
      </p>

      <h2>Rescheduling and cancellations</h2>
      <p>
        We understand plans change. Please contact us as early as possible so we can accommodate your
        pet and other families.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms? Email us at
        <a href="mailto:hello@rufflesandshinegrooming.co.uk">hello@rufflesandshinegrooming.co.uk</a>.
      </p>
    </div>
  </div>
</section>
